module.exports = __webpack_public_path__ + "static/img/news5.fe0b892.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news5.png
// module id = Y/ID
// module chunks = 52